<template>
    <div>
        <table class="currency-matrix">
            <thead>
            <tr>
                <th class="currency-matrix__head-cell"/>
                <th v-for="curr in matrixHeaders" class="currency-matrix__head-cell">
                    {{ curr }}
                </th>
            </tr>
            </thead>

            <draggable v-model="matrixRows"
                       tag="tbody"
                       group="rows"
                       @start="draggingRows = true"
                       @end="draggingRows = false">
                <tr v-for="curr in matrixRows" class="currency-matrix__row">
                    <td v-for="value in curr">
                        {{ value }}
                    </td>
                </tr>
            </draggable>

        </table>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "CurrencyMatrix",
    props: {
        exchangeDate: {
            type: [String, Date],
            required: false
        },
        currencies: {
            type: Array,
            required: true
        },
        useLastKnownRate: {
            type: Boolean,
            default: true
        }
    },
    data: function () {
        return {
            draggingRows: false,
            matrixHeaders: [],
            matrixRows: [],
            originalMatrixRows: [],
        }
    },
    computed: {
        ...mapState('currencies', {
            exchangeRates: 'exchangeRates'
        }),
    },
    methods: {
        countCurrenciesRows() {
            const filteredRates = this.exchangeRates.filter(curr => this.matrixHeaders.includes(curr.secondaryCurrency));

            const againstCZK = [
                ...this.matrixHeaders
                    .map(currencyCode => {
                        const currencyRates = filteredRates.find(values => values.secondaryCurrency === currencyCode);

                        if (currencyRates) {

                            let rate = currencyRates.rates.find(rate => this.$moment(this.exchangeDate).isSame(rate.date, 'day'));

                            if (this.useLastKnownRate && !rate) {
                                rate = currencyRates.rates.find(rate => this.$moment(this.exchangeDate).isAfter(rate.date));
                            }

                            return {
                                code: currencyRates.secondaryCurrency,
                                value: rate ? this.$formats.formatNumber(rate.value / rate.units / 1000, '0,0.00000') : undefined
                            }
                        } else {
                            return {code: 'CZK', value: 1}
                        }
                    })
            ];

            this.matrixRows = againstCZK.map(curr => {
                const first = Number(curr.value);
                return [
                    curr.code,
                    ...againstCZK
                        .map(currIterated => {
                            if (curr.code === currIterated.code) return '1.00';
                            const second = Number(currIterated.value);

                            return isNaN(first) || isNaN(second) ? "N/A" : this.$formats.formatNumber(first / second, '0,0.00')
                        })]
            });
        }
    },
    watch: {
        currencies: {
            handler(newValue) {
                this.matrixHeaders = newValue;
                this.countCurrenciesRows();
            },
            immediate: true
        },
        exchangeDate: {
            handler() {
                this.originalMatrixRows = this.$_.cloneDeep(this.matrixRows);
                this.countCurrenciesRows();
                if (this.originalMatrixRows.length) {
                    let temp = [];
                    this.originalMatrixRows.map(rowOriginal => {
                        let row = this.matrixRows.find(rowNew => rowNew[0] === rowOriginal[0]);
                        temp.push(row);
                    })
                    this.matrixRows = temp;
                }
            },
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../styles/global";


.currency-matrix {
    border-collapse: collapse;

    &__row {
        cursor: grab;
    }

    th, td {
        //background-color: var(--background-color);
        border: 1px solid var(--table-border-color);
        padding: 8px;
        min-width: 50px;
        text-align: center;
    }

    tr:nth-child(even) {
      background-color: #FFFFFF0F;
    }

    td:nth-child(even) {
      background-color: #FFFFFF0F;
    }

  th:nth-child(even) {
    background-color: #FFFFFF0F;
  }
    //td:nth-child(odd) {
    //    background-color: var(--table-body-color);
    //}

}

.sortable-chosen {
    > td {
        background-color: var(--table-body-highlight-color) !important;

    }
}


</style>